// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// components.
import { RulePanelRow } from "./RulePanelRow";

interface ConfianzaPanelProps {
  rules: RawRuleItem[];
  onEdit: (rule: RawRuleItem) => void;
  onToggle: (rule: RawRuleItem) => void;
}

export const ConfianzaPanel = ({ rules, onEdit, onToggle }: ConfianzaPanelProps) => {
  const activeCount = rules.filter((r) => r.is_active === "active").length;
  const sorted = [...rules].sort((a, b) => a.rule.priority - b.rule.priority);

  return (
    <div className="dashboard-panel dashboard-panel--confianza">
      <div className="panel-header panel-header--confianza">
        <div className="panel-title-group">
          <span className="boxing-label label--confianza">🛡️ Confianza</span>
          <p className="panel-title">Rutas de confianza</p>
          <span className="panel-count count--confianza">
            {activeCount} activa{activeCount !== 1 ? "s" : ""}
          </span>
        </div>
      </div>

      <div className="panel-body">
        {sorted.length === 0 ? (
          <p className="panel-empty">No hay rutas de confianza para esta sub-ruta.</p>
        ) : (
          sorted.map((rule) => (
            <RulePanelRow
              key={rule.rule_id}
              rule={rule}
              variant="confianza"
              onEdit={onEdit}
              onToggle={onToggle}
            />
          ))
        )}
      </div>
    </div>
  );
};
